<template>
    
    <button :type="type" @click="onClick" :class="computedClass" :disabled="disabled">
        <spinner v-if="loading"></spinner>
        <span v-else-if="successStateVisible" class="flex items-center space-x-1">
            <heroicon icon="check" class="w-5 h-5"></heroicon>
            <span>Saved</span>
        </span>
        <slot v-else></slot>
    </button>

</template>
<script>

import spinner from './Spinner'
import heroicon from './Heroicon'

export default {
    components: {
        spinner,
        heroicon
    },
    props: {
        type: { default: 'button' },
        size: { default: 'medium' },
        color: { default: 'blue' },
        theme: { default: 'primary' },
        loading: { default: false },
        disabled: { default: false }
    },
    data() {
        return {
            successStateVisible: false 
        }
    },
    computed: {
        computedSize() {
            switch (this.size) {
                case 'xsmall':
                    return 'px-2.5 py-1.5 text-xs';
                case 'small':
                    return 'px-3 py-2 text-sm leading-4';
                case 'large':
                    return 'px-4 py-2 text-base';
                case 'xlarge':
                    return 'px-6 py-3 text-base';
                case 'medium': 
                default:
                    return 'px-4 py-2 text-sm';
                
            }
        },
        computedColor() {
            switch (this.theme) {
                case 'outline':
                    return `border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-${this.color}-500`;
                case 'stripe':
                    return `border-stripe bg-stripe text-white hover:opacity-90 focus:ring-stripe`
                case 'primary':
                default:
                    return `bg-${this.color}-600 hover:bg-${this.color}-700 focus:ring-${this.color}-500 border-transparent text-white`;
            }
        },
        computedClass() {
            return `inline-flex justify-center items-center ${this.computedSize} border shadow-sm font-medium rounded-md ${this.computedColor} focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50`;
                    
        }
    },
    methods: {
        onClick() {
            this.$emit('click')
        },
        showSuccessState() {
            this.successStateVisible = true;

            setTimeout(() => this.successStateVisible = false, 2000);
        }
    }
}
</script>